import {getOneMenu, getTwoMenu, getAllMenu} from 'api/menu/menu'
const menu = {
  state: {
    oneMenu: null,
    twoMenu: null,
    allMenu: null
  },
  mutations: {
    SET_ONE_MENU: (state, item) => {
      state.oneMenu = item
    },
    SET_TWO_MENU: (state, item) => {
      state.twoMenu = item
    },
    SET_ALL_MENU: (state, item) => {
      state.allMenu = item
    }
  },
  actions: {
    setOneMenu ({ commit }) {
      getOneMenu().then(function (res) {
        if (res.type === 'success') {
          commit('SET_ONE_MENU', res.data)
        }
      });
    },
    setTwoMenu ({ commit }, id) {
      return new Promise((resolve, reject) => {
        getTwoMenu(id).then(res => {
          if (res.type === 'success') {
            commit('SET_TWO_MENU', res.data)
          }
          resolve(res.data[0]['subFunctions'][0]['id']);
        }).catch(error => {
          reject(error);
        });
      });
    },
    setAllMenu ({ commit }) {
      getAllMenu().then(function (res) {
        if (res.type === 'success') {
          var menu = [];
          var allMenu = res.data;
          for (var i = 0, count = allMenu.length; i < count; i++) {
            menu = menu.concat(allMenu[i].subFunctions);
          }
          commit('SET_ALL_MENU', menu)
        }
      });
    }
  }
}

export default menu



// WEBPACK FOOTER //
// ./src/store/modules/menu.js